exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* START EVOQ COLOR PALETTE */\n/* END EVOQ COLOR PALETTE */\n/* START ATTENTION COLORS */\n/* END ATTENTION COLORS */\n/* SVG HOVER STATES */\nsvg {\n  fill: #C8C8C8;\n}\nsvg:hover {\n  fill: #6F7273;\n}\nsvg:active {\n  fill: #1E88C3;\n}\n/* END SVG HOVER STATES */\n._1cHO0hEULISjjQ8Jh-fIN2 {\n  background-color: #F7F8F9;\n  padding: 20px;\n  margin-bottom: 20px;\n}\n", ""]);

// Exports
exports.locals = {
	"pageUrl": "_1cHO0hEULISjjQ8Jh-fIN2"
};